import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings__title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { LotteryDrawWinning } from "@/lotteries/services/model/lottery-draw-winning";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-addon-winnings',
  props: {
    lottery: {},
    winnings: {}
  },
  setup(__props: any) {

const props = __props;

const addonDisplayName = LotteryParser.addonDisplayName(props.lottery);
const showGuessedColumn = props.lottery === Lottery.sportka || props.lottery === Lottery.eurojackpot;

const guessedText = [
    "Celé šestičíslí",
    "Koncové pětičíslí",
    "Koncové čtyřčíslí",
    "Koncové trojčíslí",
    "Koncové dvojčíslí",
    "Koncové číslo",
    "Koncové číslo +/- 1",
];

const formatNumberOfWinners = (winners: number) => {
    const formattedWinners = StringUtils.formatNumber(winners);
    return props.lottery === Lottery.euromiliony ? `/ ${formattedWinners}x` : `(${formattedWinners}x)`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(addonDisplayName)), 1),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Pořadí")
              ])),
              _: 1,
              __: [0]
            }),
            (_unref(showGuessedColumn))
              ? (_openBlock(), _createBlock(DsCell, {
                  key: 0,
                  type: "th"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Uhodnuto")
                  ])),
                  _: 1,
                  __: [1]
                }))
              : _createCommentVNode("", true),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Výhra")
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.winnings, (res, index) => {
          return (_openBlock(), _createBlock(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1) + ". pořadí", 1)
                ]),
                _: 2
              }, 1024),
              (_unref(showGuessedColumn))
                ? (_openBlock(), _createBlock(DsCell, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(guessedText[index]), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  (res.amount && res.wins)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("strong", {
                          innerHTML: _unref(StringUtils).formatCurrency(res.amount)
                        }, null, 8, _hoisted_2),
                        _createElementVNode("span", {
                          innerHTML: ' ' + formatNumberOfWinners(res.wins)
                        }, null, 8, _hoisted_3)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("–––")
                      ], 64))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})